// extracted by mini-css-extract-plugin
export default {"contentContainer":"app_contentContainer__eUCpa","primaryCursive":"app_primaryCursive__ysWnF","complementary":"app_complementary__q+dqK"};